import React from 'react';

import { useKeycloak } from '@react-keycloak/web';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import DataGrid from './components/dataGrid/DataGrid';
import DraftLayout from './components/layout/DraftLayout';
import Layout from './components/layout/layout';
import ContractComponent from './Pages/Contracts/ContractComponent';
import Drafts from './Pages/Drafts';
import ViewDraft from './Pages/Drafts/ViewDraft';

function Root() {
  const { keycloak } = useKeycloak();
  const isLoggedIn = keycloak.authenticated;
  const { pathname } = useLocation();

  return (
    <Routes>
      <Route
        element={pathname.includes('/draft/') ? <DraftLayout /> : <Layout />}
      >
        <Route path="dictionary" element={<ContractComponent />} />
        <Route path="dictionary/:id" element={<DataGrid />} />
        <Route path="drafts" element={<Drafts />} />
        <Route path="draft/:id" element={<ViewDraft />} />
        {isLoggedIn && (
          <Route path="/" element={<Navigate replace to="/dictionary" />} />
        )}
      </Route>
    </Routes>
  );
}

export default Root;
